import { Component, Input, OnChanges } from '@angular/core';
import { PerformanceMA } from '../dto/PerformanceMA';
import { ExcelService } from 'src/app/domain/excel';
import { ExcelTemplateName } from 'src/app/domain/excel/interfaces';

@Component({
  selector: 'app-ma-by-company',
  templateUrl: './ma-by-company.component.html',
  styleUrls: ['./ma-by-company.component.scss'],
})
export class MaByCompanyComponent implements OnChanges {
  @Input() portfolios: PerformanceMA[];

  headers: string[] = [];
  sortMap = SORT_MAP;

  constructor(private excelService: ExcelService) { }

  ngOnChanges(): void {
    this.setHeaders();
  }

  exportExcel(): void {
    const fileName = 'ma-by-company.xlsx';
    this.excelService.exportByTemplate(this.portfolios, fileName, ExcelTemplateName.maByCompany);
  }

  private setHeaders(): void {
    this.headers = MA_BY_COMPANY_HEADERS;
  }
}

export const MA_BY_COMPANY_HEADERS = ['Organization', 'Company name', 'Industry', 'Round date',
  'Investment 0-12', 'Investment 12-24',
  'FMV 0-12', 'FMV 12-24',
  'Total raised 0-12', 'Total raised 12-24',
  '# of rounds 0-12', '# of rounds 12-24'];

const MA_BY_COMPANY_SORTING = {
  byOrganization: (pp: PerformanceMA): string => pp.orgName,
  byCompanyName: (pp: PerformanceMA): string => pp.companyName,
  bySector: (pp: PerformanceMA): string => pp.sector,
  byRoundDate: (pp: PerformanceMA): Date => pp.roundDate,
  byAmountOfCompanies: (pp: PerformanceMA): number => pp.amountOfCompanies,
  byCostYear1: (pp: PerformanceMA): number => pp.costYear1,
  byCostYear2: (pp: PerformanceMA): number => pp.costYear2,
  byFmvYear1: (pp: PerformanceMA): number => pp.fmvYear1,
  byFmvYear2: (pp: PerformanceMA): number => pp.fmvYear2,
  byTotalRoundYear1: (pp: PerformanceMA): number => pp.totalRoundYear1,
  byTotalRoundYear2: (pp: PerformanceMA): number => pp.totalRoundYear2,
  byAmountOfRoundsYear1: (pp: PerformanceMA): number => pp.amountOfRoundsYear1,
  byAmountOfRoundsYear2: (pp: PerformanceMA): number => pp.amountOfRoundsYear1,
};

const SORT_MAP = {
  0: MA_BY_COMPANY_SORTING.byOrganization,
  1: MA_BY_COMPANY_SORTING.byCompanyName,
  2: MA_BY_COMPANY_SORTING.bySector,
  3: MA_BY_COMPANY_SORTING.byRoundDate,
  4: MA_BY_COMPANY_SORTING.byAmountOfCompanies,
  5: MA_BY_COMPANY_SORTING.byCostYear1,
  6: MA_BY_COMPANY_SORTING.byCostYear2,
  7: MA_BY_COMPANY_SORTING.byFmvYear1,
  8: MA_BY_COMPANY_SORTING.byFmvYear2,
  9: MA_BY_COMPANY_SORTING.byTotalRoundYear1,
  10: MA_BY_COMPANY_SORTING.byTotalRoundYear2,
  11: MA_BY_COMPANY_SORTING.byAmountOfRoundsYear1,
  12: MA_BY_COMPANY_SORTING.byAmountOfRoundsYear2,
};
